import { useEffect } from 'react'
import { useUser } from '@paintscout/ui-business'
import { isE2E } from 'shared/util/e2e'
import { getKnownUserCookieValue, writeKnownUserCookie } from '../../util/knownUserCookie'

/** Writes the `ps_known_user` cookie for the marketing site. See `util/knownUserCookie.ts`. */
export default function KnownUserCookie(): JSX.Element {
  const { user, highestRole, isTrial, isSubscribed, isChurned, isMasquerading } = useUser()

  useEffect(() => {
    if (!user?.user_id) return

    const value = getKnownUserCookieValue({
      hostname: window.location.hostname,
      highestRole,
      isTrial,
      isSubscribed,
      isChurned,
      isMasquerading,
      isE2E: isE2E()
    })
    if (value) {
      writeKnownUserCookie(value)
    }
  }, [user?.user_id, highestRole, isTrial, isSubscribed, isChurned, isMasquerading])

  return null
}
